module.exports = __webpack_public_path__ + "static/media/sn_insta.ff8cd66c.svg";